import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { EventHubWebsiteBuilderPresentation } from './event-hub-website-builder.presentation';
import { EventHubWebsiteBuilderVM } from './event-hub-website-builder.viewmodel';
import { connectEventHubsVM } from '../event-hubs.context';

type EventHubWebsiteBuilderProps = {
    accountId: number;
    eventHubId: number;
};

const EventHubWebsiteBuilderContainer = withViewModel<EventHubWebsiteBuilderProps, EventHubWebsiteBuilderVM>(
    EventHubWebsiteBuilderPresentation,
    async props => {
        const vm = new EventHubWebsiteBuilderVM(props.accountId, props.eventHubId);
        await vm.initialize();
        return vm;
    },
    props => [props.accountId, props.eventHubId],
);

export const EventHubWebsiteBuilder = connectEventHubsVM<EventHubWebsiteBuilderProps>(EventHubWebsiteBuilderContainer, vm => ({
    accountId: vm.getAccountId(),
    eventHubId: vm.getEventHubId(),
}));
